import { getChainID } from '@/decentralizedApi/inits';

const pioneerAddresses = {
  v2Router: '0x7BEf93022D48b9df745B77D0Fd348fB415b026e2',
  v2Factory: '0x18790F963c221b002A6A8405Ce6e7b86A8ceaF11',
  WINI: '0x9e66cd15226464EFBa8b7B2847A0880AFC236c5C',
  USDT: '0x36AA81a7aEeAB8f09e154d3E779Bb81beA54501A',
  TOKEN: '0xcF259Bca0315C6D32e877793B6a10e97e7647FdE',
};

const genesisAddresses = {
  v2Router: '0x4ccB784744969D9B63C15cF07E622DDA65A88Ee7',
  v2Factory: '0x95eB95F6917Cac722d3638aDe3BdAd6B21FeBF45',
  WINI: '0xfbECae21C91446f9c7b87E4e5869926998f99ffe',
  USDT: '0xcF259Bca0315C6D32e877793B6a10e97e7647FdE',
  TOKEN: '',
};

export const contractAddressList = { 
  233: pioneerAddresses,
  7234: genesisAddresses,
};

// 获取当前链ID
const getContractAddress = () => {
  const chainId = getChainID();    
  return contractAddressList[chainId] || {}; // 如果没有对应的地址，则返回空对象
};

// 通用的获取合约地址的函数
const getContract = (contractName) => {
  const contractAddress = getContractAddress();
  return contractAddress[contractName] || null; // 如果没有找到对应的合约地址，返回 null
};

// 通过合约名称来获取合约地址
export const getFactoryAddress = () => getContract('v2Factory');
export const getRouterAddress = () => getContract('v2Router');
export const getWethAddress = () => getContract('WINI');
export const getUSDTAddress = () => getContract('USDT');
export const getTokenAddress = () => getContract('TOKEN');

